import { TemplateElement, html, defineElement } from '@webtides/element-js';
import style from './accordion-item.css';
import { AccordionToggleEvent } from '../../events/accordion-toggle-event';

/**
 * @property {boolean} open - Whether the content is visible
 * @property {'' | 'minimal'} [variant] - Visual variant. "minimal" removes borders and spacing.
 * @property {AccordionRegisterStore} accordionRegisterStore
 */
export default class AccordionItem extends TemplateElement {
    constructor() {
        super({ shadowRender: true, styles: [style], propertyOptions: { open: { reflect: true } } });
    }

    properties() {
        return {
            open: false,
            variant: '',
        };
    }

    injectProperties() {
        return {
            /** @type {AccordionRegisterStore} */
            accordionRegisterStore: (accordionRegisterStore) => {
                accordionRegisterStore.register(this);
            },
        };
    }

    connected() {
        if (this.id && window.location.hash.includes(this.id)) {
            this.open = true;
        }

        // TODO: this should be removed alongside with the FAQ component in magnolia
        this._isFaqAccordion = this.closest('.FAQ') !== null;
    }

    watch() {
        return {
            open: (open) => {
                if (this.id && !open && window.location.hash.includes(this.id)) {
                    const [url, hash] = window.location.href.split('#');
                    window.history.pushState(null, null, url);
                }
            },
        };
    }

    events() {
        return {
            '[data-toggle]': {
                click: (event) => {
                    const noToggleEl = event.target.closest?.('[data-no-toggle]');
                    if (noToggleEl) return;
                    event.preventDefault();

                    this.open = !this.open;

                    // TODO: find a more generic way to track these interactions
                    window.dataLayer?.push({
                        event: 'generic',
                        category: 'interaction',
                        action: 'body',
                        label: `${this.id} - ${this.open === true ? 'open' : 'close'}`,
                        elementName: this._isFaqAccordion ? 'faq' : 'accordion',
                    });

                    this.dispatchEvent(new AccordionToggleEvent(this, this.open));
                },
            },
        };
    }

    template() {
        return html`
            <div ref="header" class="header" data-toggle>
                <slot name="header"></slot>
                <svg class="open-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path
                        stroke="#144B3C"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.68"
                        d="m6 9 6 6 6-6"
                    />
                </svg>
                <svg class="close-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <path
                        stroke="#144B3C"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.68"
                        d="m18 15-6-6-6 6"
                    />
                </svg>
            </div>
            <div ref="content" class="content">
                <div class="content-inner">
                    <slot name="content"></slot>
                </div>
            </div>
        `;
    }
}

defineElement('mb-accordion-item', AccordionItem);
